// tslint:disable:jsx-no-lambda
import * as React from 'react';

import { Button, Modal, Progress} from '@abb/common-ux';

interface IDownloadModalState {
  selectedOption: 'blank' | 'existing';
}

interface IConfirmationModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onSubmit: (selectedOption: 'blank' | 'existing') => void;
}

export class TakeOwnershipConfirmationModel extends React.Component<IConfirmationModalProps, IDownloadModalState> {
  constructor(props: any) {
    super(props);
    
    this.state = {
      selectedOption: 'existing'
    };
  }

  onApply = () => {
    this.props.onSubmit(this.state.selectedOption);
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState(nextProps);
  }

  render() {
    const footerElem = (
      <div className='text-right'>
        <Button buttonType='normal' buttonSize='default' onClick={this.props.onClose}>Cancel</Button>
        <Button buttonType='primary' buttonSize='default' onClick={this.onApply}>Continue</Button>
      </div>
    );

    const modelContent = this.props.isLoading ? <span><Progress/></span> : <span>You are assigning this request to yourself as the ABB Parts Specialist. Your name and email will be visible to the customer when this request is approved.</span>;

    return (
      <Modal header={this.props.isLoading ? 'We are working on your request.' : 'Take Ownership'} isOpen={this.props.isOpen} onClose={this.props.onClose} footer={this.props.isLoading ? '' : footerElem} modalClassName='takeOwnershipConfirmationModal'>
        <div className='row'>
          <div className='col-sm-12'>
            {modelContent}
          </div>
        </div>
      </Modal>
    );
  }
}
